import { useState } from "react";

import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "./ui/dialog";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import padlockIcon from "../assets/icons/padlock.svg";
import logoSmall from "../assets/images/logoSmallGrey.svg";
import { ChevronDown, X } from "lucide-react";
import { Skeleton } from "../components/ui/skeleton";
import coin from "../assets/images/placeholder/crypto-colour.png";
import CurrencyFormatter from "../utils/currencyFormatter";
import { formatFiatWithTwoDecimals } from "../utils/numberFormatter";
export default function MakeDonation({
  LoadingAssets,
  onContinue,
  tradingAssets,
  selectedAsset,
  setSelectedAsset,
  childAmount,
  setChildAmount,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [flag, setFlag] = useState(false);
  const [exceedFlag, setExceedFlag] = useState(false);
  const [holdStep, setHoldStep] = useState(true);

  const filteredAssets = tradingAssets?.filter(
    (assets) =>
      assets?.asset?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      assets?.assetName?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const formatter = new CurrencyFormatter();

  const handleSelect = (asset) => {
    setSelectedAsset(asset);
    setOpen(false);
  };
  const handleContinue = () => {
    onContinue?.();
  };
  const maxAmount = () => {
    if (!selectedAsset) return;
    setChildAmount(selectedAsset?.availableAmount);
    onAmountChange({ target: { value: selectedAsset?.availableAmount } });
  };
  const onAmountChange = (e) => {
    const value = e.target.value;
    const numberRegex = /^\d*\.?\d*$/;
    const availableAmount = parseFloat(selectedAsset?.availableAmount);
    if (numberRegex.test(value)) {
      setChildAmount(value);
      const numValue = parseFloat(value);
      if (value === "" || isNaN(numValue) || numValue === 0) {
        setFlag(true);
        setHoldStep(true);
      } else {
        setFlag(false);
      }
      if (!isNaN(numValue) && numValue > availableAmount) {
        setExceedFlag(true);
        setHoldStep(true);
      } else {
        setExceedFlag(false);
        if (!isNaN(numValue) && numValue > 0) {
          setHoldStep(false);
        }
      }
    }
  };
  return (
    <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
      <div className="max-w-3xl w-full">
        <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
          <CardHeader className="px-9 pt-6 pb-4">
            <CardTitle className="text-2xl font-semibold text-text-secondary text-[20px]">
              <div className="flex items-center">
                <div>Make a donation</div>
              </div>
            </CardTitle>
          </CardHeader>

          <CardContent className="px-5 pt-2  pb-6">
            <div className="grid grid-cols-4 gap-4 grid-rows-1 py-8 px-3">
              <div className="space-y-2 col-span-1">
                <label className="text-gray-600 text-sm">Select asset</label>
                <Dialog open={open} onOpenChange={setOpen}>
                  <DialogTrigger asChild>
                    {LoadingAssets ? (
                      <div className="w-full flex items-center justify-between py-4  px-4 rounded-2xl border border-gray-300 bg-muted/50">
                        <div className="flex items-center gap-3 ">
                          <Skeleton className="w-10 h-10 rounded-full bg-gray-300" />

                          <div className="flex flex-col gap-1">
                            <Skeleton className="w-10 h-5 rounded-full bg-gray-300" />
                          </div>
                        </div>
                        <Skeleton className="w-6 h-6 rounded-full bg-gray-300" />
                      </div>
                    ) : (
                      <Button
                        variant="outline"
                        className="w-full flex items-center justify-between py-8 rounded-2xl hover:border-brand-primary transition-colors"
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-full flex items-center justify-center">
                            {selectedAsset ? (
                              <img
                                src={selectedAsset?.assetIcon}
                                alt={selectedAsset?.assetName}
                                width={32}
                                height={32}
                                className="text-white"
                              />
                            ) : (
                              <img
                                src={coin}
                                alt="Default Asset"
                                width={32}
                                height={32}
                                className="text-white"
                              />
                            )}
                          </div>
                          <div className="text-left">
                            <div className="font-semibold">
                              {selectedAsset?.asset.toUpperCase() ||
                                "Select..."}
                            </div>
                          </div>
                        </div>
                        <ChevronDown className="text-gray-400" />
                      </Button>
                    )}
                  </DialogTrigger>

                  <DialogContent className="max-w-sm rounded-2xl p-6">
                    <DialogClose asChild>
                      <Button
                        variant="ghost"
                        onClick={() => setOpen(false)}
                        className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
                      >
                        <X size={18} className="text-gray-700" />
                      </Button>
                    </DialogClose>

                    <DialogHeader>
                      <DialogTitle className="text-lg font-semibold text-gray-800">
                        Select an Asset
                      </DialogTitle>
                    </DialogHeader>
                    <div className="mt-4">
                      <input
                        type="text"
                        placeholder="Search addresses..."
                        className="w-full border rounded-lg px-3 py-2"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <div className="mt-4 flex flex-col space-y-3 max-h-72 overflow-y-auto">
                      {tradingAssets &&
                        filteredAssets.map((asset) => {
                          return (
                            <button
                              key={asset?.assetId}
                              onClick={() => {
                                handleSelect(asset);
                              }}
                              className="flex items-center gap-3 justify-between px-3 py-3 border rounded-lg border-transparent bg-gray-50 hover:border-rose-200"
                            >
                              <div className="flex items-center gap-3">
                                <img
                                  src={asset?.assetIcon}
                                  alt={asset?.assetName}
                                  className="w-6 h-6"
                                />
                                <div className="flex flex-col text-left">
                                  <span>{asset?.assetName}</span>
                                  <span className="text-xs text-gray-500">
                                    {asset?.asset?.toUpperCase()}
                                  </span>
                                </div>
                              </div>
                              <div className="flex flex-col text-right">
                                <span className="font-bold">
                                  {formatter.format(
                                    asset?.availableAmount,
                                    asset?.asset?.toUpperCase()
                                  )}
                                </span>
                                <span className="text-xs text-gray-500">
                                  {asset?.valueInLocalCurrency
                                    ? formatFiatWithTwoDecimals(
                                        asset.valueInLocalCurrency
                                      )
                                    : "R 0.00"}
                                </span>
                              </div>
                            </button>
                          );
                        })}
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
              <div className="space-y-2 col-span-3">
                <label className="text-gray-600 text-sm">
                  Available balance
                </label>
                <div className="p-5 rounded-2xl bg-gray-50 flex-1 flex items-center">
                  <div className="text-xl font-semibold text-gray-600">
                    {selectedAsset?.availableAmountFormatted}
                  </div>
                </div>
              </div>
            </div>
            <div className="columns-1 mb-6">
              <div className="space-y-2 col-span-3 px-2">
                <label className="text-gray-600 text-sm">Enter Amount</label>
                <div
                  className={`flex items-center gap-4 rounded-2xl p-3 border ${
                    flag || exceedFlag ? "border-2 border-rose-500 " : " "
                  }`}
                >
                  <input
                    type="text"
                    value={childAmount}
                    onChange={onAmountChange}
                    className={`flex-1 text-base md:text-sm font-semibold bg-transparent outline-none 
    focus-visible:ring-0 focus-visible:outline-none transition-colors duration-200 ease-in-out
    ${flag || exceedFlag ? "text-rose-500" : "text-brand-primary"}`}
                    placeholder="Enter amount"
                  />

                  <div className="flex items-center gap-2">
                    <Button
                      onClick={maxAmount}
                      variant="outline"
                      className="rounded-full"
                    >
                      Max
                    </Button>
                  </div>
                </div>
                {flag && (
                  <p className="mt-1 text-sm text-rose-500">
                    This amount is less than the allowed amount
                  </p>
                )}
                {exceedFlag && (
                  <p className="mt-1 text-sm text-rose-500">
                    This amount is more than your available amount{" "}
                    {formatter.format(
                      selectedAsset?.availableAmount,
                      selectedAsset?.asset?.toUpperCase()
                    )}
                  </p>
                )}
              </div>
            </div>
            <div className="flex justify-center py-3">
              <Button
                disabled={exceedFlag || flag || holdStep}
                className="bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2 rounded-full w-[40%]"
                onClick={handleContinue}
              >
                Continue
              </Button>
            </div>
          </CardContent>
          <Separator />
          <div className="py-4 text-[14px] text-text-secondary font-normal">
            <div className="flex justify-center items-center">
              <img src={padlockIcon} alt="Padlock icon" className="mr-1" />
              <p>Secured by</p>
              <img src={logoSmall} alt="Logo" className="ml-1" />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
